<template>
    <div class="getStartedContainer" data-aos="zoom-in">
        <div class="getStartedDiv has-text-white has-text-centered">
            <!-- <div class="has-text-left"><img v-if="!get" class="bottom20" src="@/assets/img/sIcon2.png" width="250" /></div> -->
            <div v-show="step == 1 || step == 11" class="has-text-left">
                <div>
                    <div class="mainTFLabel isPoppins"><b>slink.com/</b></div>
                    <div class="is-inline-block posRel">
                        <input id="slinkField" @keyup.enter="doSlink" type="text" class="niceInput larger is-inline-block" name="slinkinput" autocomplete="slinkinput"  :placeholder="placeholder" v-model="slink"/>
                        <button id="goSlinkButt" class="button is-turk has-text-black" @click="doSlink">GO</button>
                    </div>
                    <div v-if="step == 11" class="is-size-4 top20">Sorry, this slink is already in use</div>
                   
                </div>
                
            </div>

            <div v-show="step == 2" class="">
                <!-- <div class="has-background-grey-light is-size-4 has-text-white">&nbsp;<b>Yes!</b></div> -->
                <div class="is-size-4 top10"><span class="has-text-white">slink.com/<span class="has-text-yell is-size-3"><b>{{slink}}</b></span> is available.</span></div>
                <div class="top10">
                    <button class="button  is-mag bottom5" @click="tryIt"><b>Try For Free</b></button>&nbsp;
                    <button class="button  is-mag" @click="addIt"><b>Add to Cart</b></button>&nbsp;
                    <button class="button " @click="cancel"><b>Cancel</b></button>&nbsp;
                </div>
            </div>
                
            <div v-show="step == 3" class="top10">
                <div class="is-size-4 lineHeight4b has-text-white">Where would you like to point the slink, <span class="has-text-yell"><b>{{slink}}</b>?</span></div>
                <div class="is-inline-block posRel">
                 <input type="text" class="niceInput larger top20" placeholder="enter or copy/paste URL"  v-model="url"/>
                </div>
                <br>
                <div class="top15 has-text-white">This can be a webpage, social media profile or post, etc...</div>
                <div class="top20">
                    <button class="button is-mag" @click="nextVal(4)"><b>Next</b></button>&nbsp;
                    <button class="button" @click="cancel"><b>Cancel</b></button>&nbsp;
                </div>
            </div>

            <div v-show="step == 4" class="top20">
                <div v-show="!$root.isAuth">
                    <div v-show="!exists" class="has-text-white">
                        <div class="is-size-4">If you have an account please <button class="button is-small  is-mag" @click="$root.showModalLogin">LOG IN</button></div>
                        <div class="is-size-5 top20">if not, what is your email address?</div>
                        <input type="text" class="niceInput larger top10" placeholder="enter your email address" v-model="email"/>
                        <br>
                        <div class="top20">
                            <button id="chkButt" class="button is-mag" @click="checkEmail"><b>Next</b></button>&nbsp;
                            <button class="button" @click="cancel"><b>Cancel</b></button>&nbsp;
                        </div>
                    </div>
                    <div v-show="exists" class="has-text-white">
                        <div v-show="!FCP">
                            <div class="is-size-4">An account under this email already exists.</div>
                            <div class="is-size-4 top10">Please <button class="button is-mag top-5" @click="$root.showModalLogin">LOG IN</button></div>
                        </div>
                            <div v-show="FCP">
                            <div class="is-size-4">You have already initiated another trial with this email address.<br> Please check your email for an activation link, or click the button below to have it resent.</div>
                            <div class="is-size-4"><button class="button is-mag top10" @click="resend">Resend</button></div>
                        </div>
                            <button class="button  top20" @click="cancel"><b>Cancel</b></button>&nbsp;
                    </div>
                </div>

                <div v-show="$root.isAuth">
                    <div class="is-size-4"><span class="has-text-white">slink.com/</span><b><span class="has-text-yell is-size-3">{{slink}} </span><span class="has-text-white">is ready!</span></b></div>
                    <div class="top20">
                        <button id="startTrialButt" class="button is-mag " @click="authTrial"><b>Start Trial</b></button>&nbsp; 
                        <button class="button " @click="cancel"><b>Cancel</b></button>&nbsp;
                    </div>
                    

                </div>
            </div>
            
            <div v-show="step == 6" class="top20">
                <div v-if="!$root.isAuth" class="has-text-white">
                    <div class="is-size-3"><b>Check your email!</b></div>
                    <div><b>Verify your email to activate your Slink trial.</b></div>
                    <div class="top15 is-size-4 "> Your slink will expire in <span class="has-text-yell"><b>30 days</b></span> unless you purchase it before that.</div>
                    <button class="button is-mag top15" @click="cancel">OK</button>
                   <!--  <div class="top10" >Promote your new slink everywhere. For suggestions on how to use it, please visit HOW TO USE</div> -->
                    
                </div>

                <div v-if="$root.isAuth" class="has-text-white">
                    <div class="is-size-4"><b>Your Trial is set!</b></div>
                    <div class="top20 is-size-5 ">You can change it's redirection URL and add subslinks from the <b>Manage Services</b> section of your account.</div>
                    <button class="button is-mag top15" @click="cancel">OK</button>
                </div>
            </div>


            <div v-show="step == 8" class="top20 has-text-white">
                <div class="is-size-4"><b>Sorry, but someone beat you to reserving this slink.</b></div>
                <button class="button top15" @click="cancel"><b>OK</b></button>
            </div>

            <div v-show="step == 9" class="top20 has-text-white">
                <div class="is-size-4"><b>Cannot repeat trial of a slink</b></div>
                
            </div>

           

                    

        </div>

    </div>

</template>

<script>

import constants from '../STATIC/constants'

export default{

    props: { 
        get: {
            type: Boolean,
            default: false
        }
    }, 
    
    data: function(){
        return {
            step: 1,
            slink: '',
            email: '',
            url: '',
            pwd: '',
            fName: '',
            lName: '',
            terms: '',
            recaptcha: false,
            exists: false,
            showPwd: false,
            FCP: false,
            placeholder: az.noSlash(this.$route.fullPath) == '/get' ? '  enter your slink' : '  slink one or create one'
        }
    },

    mounted: function(){
        /* document.getElementById('topLogo').style.display = 'none'
        document.getElementsByClassName('navbar-brand')[0].style.display = 'none'
        document.getElementsByClassName('navbar-start')[0].style['margin-left'] = '0' */

         document.getElementById('slinkField').onkeypress = function(event){
            var el = document.getElementById('slinkField')
            
            var regex =  /[^a-zA-Z0-9\:@_-]/g;
            if(this.get) regex = /[^a-zA-Z0-9@_-]/g;
            if(String.fromCharCode(event.key.charCodeAt()).match(regex)){ //az.findInArr(constants.PREVENTEDCHRS, event.key.charCodeAt())
                event.preventDefault();
                /* if(event.key.charCodeAt() == 32 && el.value.slice(-1) != ':'  && self.get){        
                        el.value = el.value + ':';
                }  */
            } else if(event.key.charCodeAt() == 58 && el.value.slice(-1) == ':'){
                event.preventDefault();
            } 
     
        }

        function configRecaptcha(){

        }

        this.$root.loadScript('https://www.google.com/recaptcha/api.js', configRecaptcha)

        setTimeout(() => {
            grecaptcha.render('recaptcha-main'); // 'recaptcha-main' is the id that was assigned to the widget
        }, 200);
    },

    methods: {
        go: function(){
            this.step = 2
        },

        cancel: function(){
            this.step = 1
            this.slink = ''
            this.url = ''
            this.fName = ''
            this.lName = ''
            this.pwd = ''
            this.email = '',
            this.exists = false,
            this.terms = false,
            this.showPwd = false,
            this.FCP = false
        
        },

        tryIt: function(){
            this.step = 3
        },

        nextVal: function(val){
            
            if(val == 4){ //validate URL
                if(this.url == '') return

                var chkUrl = this.validateURL(this.url)
                if(chkUrl.error){
                    this.$root.showModalOK({message: chkUrl.err})
                    return
                } else {
                    this.url = chkUrl.url
                }
            } 
            this.$parent.$parent.s5 = true
            this.step = val
        },

        setTrial: function(){

            az.addRemSpinner(true, 'id', 'setTrialButt');

          /*   if(this.fName == '' || this.lName == '' || this.pwd == '' || this.terms == ''){
                this.$root.showModalOK({message: 'Please provide all fields.'})
                return
            } */

            //validate pwd 
          /*   if(!this.validatePwd(this.pwd)){
                this.$root.showModalOK({message: 'Password must be 8 or more characters, upper and lower case letters, at least one number, at least one special character.'})
                return
            } */

            var self = this

            //doReCaptcha()

            doRegistration()

           /*  function doReCaptcha(){
                    let rc = grecaptcha.getResponse()

                    if(rc == '' || rc == undefined){
                        self.$root.showModalOK({message: "Please complete the - I'm not a Robot - verification."})
                        return
                    }

                    function w(d){
                        if(d.r == 'ok'){
                            doRegistration()
                            console.log('recaptcha return')
                        } else {
                            self.$root.showModalOK({message: 'Robot Verification returned an error, please reload the page and try again.'})
                        }
                    }

                    function n(){
                    //
                    }

                    self.$root.apiClient.post('', {token: rc}, w, n)
            } */

            function doRegistration () {

               

                az.addRemSpinner(true, 'id', 'save');
        
                    /* var attributes = [
                        {Name: 'given_name', Value: self.fName},
                        {Name: 'family_name', Value: self.lName},
                    ]
            
                    self.$root.azCognito.signUp(self.email.toLowerCase(), self.pwd, attributes, signUpCallback)
            
                    function signUpCallback (result, obj) {
                        
                        az.addRemSpinner(false, 'id', 'save');
                        if (result == 'error') {
                            if (obj.code == 'UsernameExistsException') {
                                self.$root.showModalOK({message: 'The email you provided is already in use, please provide a different one.'})
                            } else {
                                self.$root.showModalOK({message: 'There was an error processing your request. Please try again later or contact support.'})
                            }
                            return
                        } */
                      

                        function w(d){
                            az.addRemSpinner(false, 'id', 'setTrialButt');
                            if(d.result == 'exists'){
                                
                            } else if(d.result == 'ok'){
                                self.$parent.$parent.s5 = true
                                self.step = 6
                            }
                        }

                        function n(){   
                            az.addRemSpinner(false, 'id', 'setTrialButt');
                        }

                       
                        self.$root.apiClient.post('api/account/pendingtrial', {email: self.email, slink: self.slink, url: self.url}, w, n)
                    //}

            }
        },

        authTrial: function(){
            var self = this
            function w(d){
                az.addRemSpinner(false, 'id', 'startTrialButt')
                self.$parent.$parent.s5 = true
                if(d.result == 'ok'){
                    self.step = 6
                } else if(d.result == 'taken'){
                    self.step = 8
                } else if(d.result == 'repeat'){
                    self.step = 9
                } else {
                    self.$root.showModalOK({message: 'There was en error processing your request, please refresh your browser and try again.'})
                }
            }
            function n(){
                  az.addRemSpinner(false, 'id', 'startTrialButt')
            }

            az.addRemSpinner(true, 'id', 'startTrialButt')
            this.$root.apiClient.post('api/account/mngslink/createtrial', {slink: this.slink, url: this.url}, w, n)
        },

        checkEmail: function(){

            if(this.email == ''){
                return
            } else if(!this.validateEmail(this.email)){
                this.$root.showModalOK({message: 'Please provide a valid email address.'})
                return
            }

            var self = this
            function w(d){
                
                if(d.result != 'not exists'){
                     self.exists = true
                    az.addRemSpinner(false, 'id', 'chkButt');
                    if(d.result == 'FCP'){
                        self.FCP = true
                    } 
                   
                } else if(d.result == 'not exists'){
                    //self.step = 5
                    //self.$parent.$parent.s5 = false
                    //document.getElementById('pwd').type = 'password'

                    self.setTrial()
                }
            }

            function n(){
                 az.addRemSpinner(false, 'id', 'chkButt');
            }
            az.addRemSpinner(true, 'id', 'chkButt');
            this.$root.apiClient.post('api/account/chkemail', {email: this.email}, w, n)

        },

         doSlink: function () {
      
            this.$root.snf = false
            var regex =  /[^a-zA-Z0-9\:@_-]/g;
            
            if(this.slink == '' || this.slink == undefined || this.slink == ':' || this.slink.substring(0, 1) == ':'){
                if(this.slink == ':' || this.slink.substring(0, 1) == ':'){
                  this.$root.showModalOK({message: 'A slink may not begin with a colon.'})
                } 
                return
            } else if(document.getElementById('slinkField').value.match(regex)){
                
                this.$root.showModalOK({message: 'A slink may not contain accented or special characters.'})
                return
            }

            if(this.slink.toLowerCase() == 'slink'){
                this.$root.showModalOK({message: 'Sorry, this word cannot be used as a Slink.'})
                return
            }

            var self = this
            az.addRemSpinner(true, 'id', 'goSlinkButt');
            self.worked = function (data) {
                az.addRemSpinner(false, 'id', 'goSlinkButt');
                var fromGet = false;
                if(self.get){
                    fromGet = true
                }
                self.$root.processReturnedFromApi(data, fromGet)
            }
            self.noWorked = function () {
                az.addRemSpinner(false, 'id', 'goSlinkButt');
                self.$root.showModalOK({message: 'There was en arror slinking your slink'})
            }
            self.$root.apiClient.get('api/slink/' + encodeURIComponent(self.slink.toLowerCase()), {}, self.worked, self.noWorked)
            }, 
            
            addIt: function(){
                this.$root.addToCart('slink', this.slink, constants.SLINK_YEARLY_PLAN.plan); 
                this.$root.showSlinkAvail = false; 
                window.scrollTo(0,0)
                this.cancel()
		    },

            validateURL: function(val){
                //validate url structure and provide default http=:// if necessary
                //prevent redirect to a slink
                var err = ''

                if(val.substring(0, 17) == "http://slink.com/" 
                    || val.substring(0, 17) == "http://slink.com/" 
                    || val.substring(0, 18) == "https://slink.com/" 
                    || val.substring(0, 10) == "slink.com/" 
                    || val.substring(0, 9) == "slink.com"
                    || val.split('slink.com').length > 1){
                    err = {error: true, err: 'You may not redirect to another slink'};
                    return err
                }

                var urlArr = val.split('://')

                if(urlArr.length == 1){
                    if(val.split(':').length < 2){

                        if(val != ''){
                            val = 'http://' + val
                            var dotUrl = val.split('.')
                            if(dotUrl.length < 2 && val != 'http://'){
                                err = {error: true, err: 'You must provide a valid URL'};
                                return err
                            }
                        }
                        
                    } 
                } 

                return {error: false, url: val}
            },

            validateEmail: function(email){
               
                return String(email)
                    .toLowerCase()
                    .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
                
            },

            validatePwd: function(pwd){
                 return String(pwd)
                    .match(
                    /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/
                    );
            },

            togglePwd: function(){
                this.showPwd = !this.showPwd
                if(this.showPwd){
                    document.getElementById('pwd').type = 'text'
                } else {
                    document.getElementById('pwd').type = 'password'
                }
            },

            test: function(){
                var self = this
                function w(d){

                }
                function n(){

                }
                this.$root.apiClient.post('api/account/temptrial', {email: 'ale@ale.com'}, w, n)
            },

            resend: function(){
                var self = this
                function w(d){

                }
                function n(){

                }
                this.$root.apiClient.post('api/account/resendactivation', {email: self.email}, w, n)
            }

       
    }

}


</script>


// WEBPACK FOOTER //
// src/components/GetStarted.vue